<template>
  {{ $t('resource.list') }} <BoxIcon class="w-4 h-4 ml-2 mr-2" />
  <LoadingIcon icon="three-dots" class="w-8 h-8" v-show="loading" />
  <ul v-show="!loading">
    <template v-for="resource in resources" :key="resource.uuid">
      <li v-if="this.selectedResources.includes(resource.uuid)">
        <router-link
          :to="{
            name: 'side-menu-resources-detail',
            params: { uuid: resource.uuid }
          }"
          tag="a"
        >
          <ArrowUpLeftIcon class="w-4 h-4 mr-1 ml-2" />
          {{ resource.internalName }}
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
import { defineComponent } from 'vue'
import resourceApi from '../../services/resources/resource.api'

export default defineComponent({
  data() {
    return {
      resources: [],
      loading: true
    }
  },
  mounted() {
    resourceApi.getList(1, 100).then(
      response => {
        this.resources = response.data.data
        this.loading = false
      },
      error => {
        console.log(error)
        this.loading = false
      }
    )
  },
  props: {
    selectedResources: {
      type: Array,
      default: () => []
    }
  }
})
</script>
